export default {
    app: {
        drawerTitle: 'Tobačna',
        title: 'Tobačna',
        shortTitle: 'NC - Tobačna',
        icon: 'language',
        appKey: 'JQ59RYEU4KC'
    },

    user: {
        id: null,
        name: null,
        email: null,
        role: null,
        permissions: null,
        access_token: null,
        last_seen: null
    },

    drawer: null,
    loader: false,
    progress: false,
    loaderText: '',
    toolbarTitle: '',
    search: '',

    snackbar: {
        display: false,
        y: 'bottom',
        x: 'left',
        mode: '',
        timeout: 7000,
        text: 'Hello, I\'m a snackbar'
    },

    access_log: [],
    currentRoute: null
}